import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { DashboardLoginComponent } from '../dashboard-login/dashboard-login.component';
import { DashboardComponent } from '../dashboard/dashboard.component';

// PrimeNG Imports
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';

@Component({
  selector: 'app-dashboard-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    DashboardLoginComponent,
    DashboardComponent,
    ButtonModule,
    ToolbarModule
  ],
  template: `
    <div *ngIf="!isAuthenticated">
      <app-dashboard-login (loginSuccess)="onLoginSuccess()"></app-dashboard-login>
    </div>
    
    <div *ngIf="isAuthenticated">
      <!-- Logout Toolbar -->
      <p-toolbar class="logout-toolbar">
        <div class="p-toolbar-group-start">
          <span class="welcome-text">Welcome to Dashboard</span>
        </div>
        <div class="p-toolbar-group-end">
          <p-button 
            icon="pi pi-sign-out" 
            label="Logout"
            class="p-button-outlined p-button-danger"
            (onClick)="logout()"
            pTooltip="Logout from Dashboard">
          </p-button>
        </div>
      </p-toolbar>
      
      <!-- Dashboard Component -->
      <app-dashboard></app-dashboard>
    </div>
  `,
  styles: [`
    .logout-toolbar {
      background: #f8fafc;
      border-bottom: 1px solid #e2e8f0;
      margin-bottom: 20px;
      position: relative;
      display: block;
      top: 0;
      z-index: 1000;
    }

    :host ::ng-deep .p-button {
      padding: 10px;
    }

    .welcome-text {
      font-weight: 600;
      color: #374151;
      font-size: 1rem;
    }

    /* PrimeNG customizations */
    :host ::ng-deep .p-toolbar {
      padding: 0.75rem 1rem;
    }

    :host ::ng-deep .p-button-outlined.p-button-danger {
      color: #dc2626;
      border-color: #dc2626;
    }

    :host ::ng-deep .p-button-outlined.p-button-danger:hover {
      background: #dc2626;
      color: white;
    }

    @media (max-width: 768px) {
      .logout-toolbar {
        padding: 0.5rem;
      }
      
      :host ::ng-deep .p-toolbar {
        flex-direction: column;
        gap: 0.5rem;
      }
      
      :host ::ng-deep .p-toolbar-group-start,
      :host ::ng-deep .p-toolbar-group-end {
        width: 100%;
        justify-content: center;
      }
    }
  `]
})
export class DashboardWrapperComponent implements OnInit {
  isAuthenticated: boolean = false;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    // Subscribe to authentication state
    this.authService.isAuthenticated$.subscribe(isAuth => {
      this.isAuthenticated = isAuth;
    });
  }

  onLoginSuccess(): void {
    this.isAuthenticated = true;
  }

  logout(): void {
    this.authService.logout();
    this.isAuthenticated = false;
  }
}
